import React from 'react';
import { motion } from 'framer-motion';
import SkillsCube from '../components/SkillsCube';

const Skills = () => {
  const skills = [
    {
      category: "Languages",
      items: ["Python", "JavaScript", "TypeScript", "Java", "C++", "PHP", "SQL", "HTML & CSS", "Kotlin"]
    },
    {
      category: "Frameworks & Tools",
      items: ["React", "Next.js", "Node.js", "Express.js", "Django", "GraphQL", "RESTful APIs", "Three.js", "Unity", "Tailwind CSS"]
    },
    {
      category: "Platforms & Software",
      items: ["Vercel", "Power BI", "Blender", "Microsoft Excel", "Microsoft Access", "Visio", "Linux/Unix", "Windows"]
    },
    {
      category: "Specializations",
      items: ["Machine Learning", "Computer Vision", "Computer Graphics", "Computer Architecture", "Cybersecurity", "Electronics", "Physics"]
    }
  ];

  return (
    <section id="skills" className="py-20 px-4 md:px-8 lg:px-16 bg-primary">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl font-bold mb-2 flex items-center">
            <span className="text-light">Skills</span>
            <span className="h-px bg-tertiary flex-grow ml-4"></span>
          </h2>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="mt-10"
          >
            <SkillsCube />
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mt-12">
            {skills.map((skillGroup, index) => (
              <motion.div
                key={skillGroup.category}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-tertiary p-6 rounded-lg shadow-lg"
              >
                <h3 className="text-xl font-bold text-secondary mb-4">{skillGroup.category}</h3>
                <ul className="space-y-2">
                  {skillGroup.items.map((skill) => (
                    <li key={skill} className="flex items-center text-dark">
                      <span className="text-secondary mr-2">▹</span> {skill}
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>
          
          <div className="mt-16 text-center">
            <p className="text-dark text-lg mb-6">
              I'm always learning and adding new skills to my repertoire.
              Currently exploring advanced applications in Computer Vision and Machine Learning, with an ongoing interest in Quantum Computing and Theoretical Physics research.
            </p>
            <motion.a
              href="#projects"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="inline-block py-3 px-6 border-2 border-secondary text-secondary font-medium rounded hover:bg-secondary/10 transition-all duration-300"
            >
              See My Work
            </motion.a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Skills;
